import { render, staticRenderFns } from "./inberror.vue?vue&type=template&id=4d1f2b7f&scoped=true"
import script from "./inberror.vue?vue&type=script&lang=js"
export * from "./inberror.vue?vue&type=script&lang=js"
import style0 from "./inberror.vue?vue&type=style&index=0&id=4d1f2b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f2b7f",
  null
  
)

export default component.exports